var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 6.72447C7.5807 6.72447 8.86216 5.443 8.86216 3.86223C8.86216 2.28147 7.5807 1 5.99993 1C4.41916 1 3.1377 2.28147 3.1377 3.86223C3.1377 5.443 4.41916 6.72447 5.99993 6.72447Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86223 7.87109H9.06374C9.48224 7.87121 9.8863 8.02415 10.2 8.30116C10.5137 8.57818 10.7154 8.96021 10.7673 9.37548L10.9912 11.1638C11.0113 11.3249 10.9969 11.4885 10.949 11.6436C10.9011 11.7987 10.8208 11.9419 10.7133 12.0636C10.6058 12.1853 10.4737 12.2827 10.3257 12.3495C10.1777 12.4162 10.0172 12.4507 9.85486 12.4507H2.14514C1.98279 12.4507 1.82228 12.4162 1.67427 12.3495C1.52627 12.2827 1.39415 12.1853 1.28669 12.0636C1.17922 11.9419 1.09887 11.7987 1.05097 11.6436C1.00307 11.4885 0.988704 11.3249 1.00884 11.1638L1.23209 9.37548C1.28401 8.96002 1.48592 8.57783 1.79986 8.30078C2.1138 8.02374 2.51814 7.87093 2.93684 7.87109H3.13777",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.be5f5cf502a933cdb38f8fbd029200a4.svg";
export { ForwardRef as ReactComponent };